import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { authService, type User } from '../src/services/authService';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
  redirectTo?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles = [],
  redirectTo = '/backend/applications'
}) => {
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      try {
        setLoading(true);
        const user = await authService.getCurrentUser();
        setCurrentUser(user);
      } catch (error) {
        console.error('Failed to load user in ProtectedRoute:', error);
      } finally {
        setLoading(false);
      }
    };

    loadUser();
  }, []);

  // Show loading while checking user
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  // If no user, redirect to login
  if (!currentUser) {
    return <Navigate to="/" replace />;
  }

  // Check if user has required role
  if (allowedRoles.length > 0) {
    console.log('ProtectedRoute - Checking roles:', {
      allowedRoles,
      userGroups: currentUser.groups,
      userEmail: currentUser.email
    });

    const hasRequiredRole = allowedRoles.some(role => {
      const result = authService.isInGroup(currentUser, role);
      console.log(`ProtectedRoute - Role check: ${role} = ${result}`);
      return result;
    });

    console.log('ProtectedRoute - Has required role:', hasRequiredRole);

    if (!hasRequiredRole) {
      console.log(`User ${currentUser.email} does not have required role. Redirecting to ${redirectTo}`);
      return <Navigate to={redirectTo} replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
